//
// BooleanField
//
// A yes/no toggle.

import { observer } from 'mobx-react-lite'

import { HView, Spacer, VView } from '../../../../appview'
import { BooleanInput } from '../../../../components'
import { ValidationMessage } from '../../../../components/ValidationMessage'
import { validateField } from '../../../../stores/data/validators'
import { VALIDATION } from '../../../../utils/validation'

export const BooleanField = observer(function BooleanField(props) {
    const {
        className,
        record,
        field,
        fromClass,
        component,
        enabled,
        force_readonly,
        renderkey,
        worksheet,
        visited_gids,
        ...other
    } = props

    let classes = 'cc-Field cc-BooleanField'
    if (className) classes += ' ' + className

    const fieldvalue =
        record.localized_fields && record.localized_fields.get(field.name)

    const validation = validateField(fieldvalue, field, record.language)

    if (validation) {
        if (validation.result === VALIDATION.ERROR) {
            classes += ' validation-error'
        } else if (validation.result === VALIDATION.REPORT) {
            classes += ' validation-report'
        }
    }

    const onSetValue =
        enabled && !force_readonly
            ? newValue => {
                  record.setField(field, newValue)
                  record.commitIfModified()
              }
            : undefined

    return (
        <VView className={classes} {...other}>
            <HView>
                <BooleanInput value={fieldvalue} onSetValue={onSetValue} />
                <Spacer grow />
            </HView>
            <ValidationMessage validation={validation} />
        </VView>
    )
})
